import { render, staticRenderFns } from "./Activity_post.vue?vue&type=template&id=4874ded2&style=height%3A100%25"
import script from "./Activity_post.vue?vue&type=script&lang=js"
export * from "./Activity_post.vue?vue&type=script&lang=js"
import style0 from "./Activity_post.vue?vue&type=style&index=0&id=4874ded2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports